import { useContext, useEffect, useState } from "react";
import Recommendations from "./Recommendations";
import News from "./News";
import { useNavigate } from "react-router-dom";
import { UiTextsContext } from "../../../contexts/Contexts";
import { showNoticesService } from "../../../../infrastructure/services/NoticesService";
import { UserDataContext } from "../../../contexts/Contexts";
import { useSocialMessages } from "../../../../infrastructure/hooks/useInterfaceMessages";
import ChatSiderHome from "../../../pages/chat/SideBarChat/ChatSiderHome";
import { useChatConversations } from "../../../pages/chat/hooks/useChatConversations";
import {
  archiveChatService,
  deleteChatService,
} from "../../../../infrastructure/services/ChatService";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../../utils/messages";
import { preloadChatEmojiCatalog } from "../../../../infrastructure/utils/chatEmojiCache";

import "./styles/MainComponent.css";

export const MainContainer = () => {
  const { texts } = useContext(UiTextsContext);
  const socialMessages = useSocialMessages();
  const { userData } = useContext(UserDataContext);

  const navigate = useNavigate();

  const [noticesList, setNoticesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeConversationFilter, setActiveConversationFilter] = useState("all");
  const {
    contacts,
    counters,
    loadingContacts,
    isRefreshingContacts,
    fetchContacts,
    fetchCounters,
    removeConversation,
    archiveConversation,
  } = useChatConversations(userData?.idUsuario, activeConversationFilter);

  // Mostrar Noticias
  const getNotices = async () => {
    try {
      setLoading(true);
      const response = await showNoticesService();
      if (response?.data) {
        setNoticesList(response.data);
      }
    } catch (error) {
      console.error("Failed to get notices", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNotices();
  }, []);

  useEffect(() => {
    if (!userData?.idUsuario) {
      return;
    }

    preloadChatEmojiCatalog().catch((error) => {
      console.error("Failed preloading chat emojis on home", error);
    });
  }, [userData?.idUsuario]);

  const handleClick = () => {
    navigate("/blogSection");
  };

  const handleArchiveChat = async (contact) => {
    if (!contact?.idChat || !userData?.idUsuario) {
      showErrorMessage(socialMessages.missingChatId);
      return;
    }

    try {
      await archiveChatService({
        idChat: contact.idChat,
        userId: userData.idUsuario,
      });

      archiveConversation(contact.idChat);
      fetchContacts();
      fetchCounters();
      showSuccessMessage(socialMessages.chatArchived);
    } catch (error) {
      console.error("Error archiving chat:", error);
      showErrorMessage(socialMessages.archiveChatFailed);
    }
  };

  const handleDeleteChat = async (contact) => {
    if (!contact?.idChat || !userData?.idUsuario) {
      showErrorMessage(socialMessages.missingChatId);
      return;
    }

    try {
      await deleteChatService({
        idChat: contact.idChat,
        userId: userData.idUsuario,
      });

      removeConversation(contact.idChat);
      fetchContacts();
      fetchCounters();
      showSuccessMessage(socialMessages.chatDeleted);
    } catch (error) {
      console.error("Error deleting chat:", error);
      showErrorMessage(socialMessages.deleteChatFailed);
    }
  };

  return (
    <div className="main-container-mc">
      <div className="sidebar-left-mc">
        <div className="recommendations-wrapper-mc">
          <Recommendations loadingRecomendations={loading} />
        </div>

        <div className="news-section-mc">
          <h2
            className="home-side-title-mc home-side-title-mc--clickable"
            onClick={handleClick}
          >
            {texts?.LB0288 || "Nomad Alert"}
          </h2>
          <News
            dataList={noticesList}
            loading={loading}
            onClickNews={handleClick}
          />
        </div>
      </div>

      <div className="chat-section-mc">
        <div className="chat-wrapper-mc">
          <ChatSiderHome
            contacts={contacts}
            counters={counters}
            loading={loadingContacts}
            isRefreshing={isRefreshingContacts}
            activeFilter={activeConversationFilter}
            onFilterChange={setActiveConversationFilter}
            onArchiveChat={handleArchiveChat}
            onDeleteChat={handleDeleteChat}
          />
        </div>
      </div>
    </div>
  );
};

export const MainContainerMobile = () => {
  return (
    <div className="main-container-mobile-mc">
      {/* Sección de recomendaciones */}
      <div className="recommendations-mobile-mc">
        <Recommendations />
      </div>
    </div>
  );
};
export const LowResolutionDesktops = () => {
  <div className="main-container-mobile-mc">
    {/* Sección de recomendaciones */}
    <div className="recommendations-mobile-mc">
      <Recommendations />
    </div>
  </div>;
};
